

<div class="modal-title-bg text-left" >
  <div class="col float-left ml-4 mt-1">
    <h2 class="text-white">{{ title | translate }}</h2>
  </div>
  <div class="col float-right mr-5" style="margin-left: 92.5%;margin-top: -40px;">
    <button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>




<div style="height: 100px">
  <div class="box ml-2  mr-2" >
    <div class="box-header">
      @if (!isLoading) {
        <div class="overlay">
          <mat-progress-bar mode="indeterminate"  style="height:3px"></mat-progress-bar>
        </div>
      }
      <div class="box-body">
        <form [formGroup]="reauthForm">
          <div class="col form">
            <div class="row mt-3" style="justify-content: center;">


              <div class="col" >


                <mat-form-field appearance="outline" style="width: 520px;">
                  @if (orderType==='OC') {
                    <mat-label>{{'Enter your User ID to approve this OC' | translate}}</mat-label>
                  }
                  @if (orderType==='RC') {
                    <mat-label>{{'Enter your User ID to approve this RC' | translate}}</mat-label>
                  }
                  <input matInput required maxlength="100"  formControlName="upn" />
                </mat-form-field>




              </div>






              <div class="col">

                <button mat-raised-button  class="ml-2  mb-2 ml-sm-auto" (click)="approve()" >
                  {{'Confirm' | translate}}
                </button>
              </div>
              <div class="col">
                <div class="col text-right">
                  <p class="text-right" style="color: red;">{{message}}</p>
                </div>
              </div>

            </div>
            @if (!valid) {
              <div class="row">
              </div>
            }

          </div>
        </form>
      </div>


    </div>


  </div>

</div>